// @ts-check
import React from 'react';

/**
 * Provides callbacks to set state to true/false. Slightly reduces amount of boilerplate code.
 * E.g. for drawers, drop-downs, menus etc.
 * @param {boolean} initialState
 * @returns {[boolean, () => void, () => void]}
 */
export const useBooleanState = (initialState = false) => {
  const [state, setState] = React.useState(initialState);

  const setTrue = () => setState(true);
  const setFalse = () => setState(false);

  return [state, setTrue, setFalse];
};

export default useBooleanState;
